import "./reports-page.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import { convertLocaltoUTCFormat } from "../../../services/DateFormatUtility";
import { Badge, BADGES, COLORS } from "abs-ui-components";
export const REPORTS_TABLE_COLUMNS = [
	{
		accessorKey: "ReportId",
		accessorFn: (row) => row.ReportId || "",
		size: 50,
		enableHiding: false,
		header: "Report ID",
		Cell: ({ row, cell }) => {
			const reportId = cell.getValue();
			return (
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
					}}
				>
					<span style={{ display: "flex", alignItems: "center" }}>
						<span>{reportId}</span>
						{row?.original?.IsParentReport && reportId && !row?.original?.IsAdvantageReport && (
							<Badge
								type={BADGES.SUP}
								color={
									row?.original?.TemplateType?.includes("2.2")
										? "RGB(76,163,66)"
										: "RGB(94,138,180)"
								}
								label={
									row?.original?.TemplateType?.includes("2.2")
										? "V2.2"
										: "V1.1" 
								}
								disabled={true}
								className="ml-1"
							/>
						)}
						{row?.original?.IsParentReport && row?.original?.IsAdvantageReport && reportId && (
							<Badge
								type={BADGES.SUP}
								color={"RGB(255,165,0)"}
								label={"ADV"}
								disabled={true}
								className="ml-1"
							/>
						)}
					</span>

				</div>
			);
		},
		enableColumnFilter: false,
	},

	{
		accessorKey: "RevisionNumber",
		accessorFn: (row) => {
			return row.RevisionNumber;
		},
		header: "Revision Number",
		enableColumnFilter: false,
	},
	{
		accessorKey: "ImoNumber",
		accessorFn: (row) => {
			return row.ImoNumber || "";
		},
		enableHiding: false,
		size: 45,
		header: "IMO Number",
	},
	{
		accessorKey: "VesselName",
		accessorFn: (row) => {
			return row.VesselName || "";
		},
		header: "Vessel Name",
	},
	{
		accessorKey: "WcnNumber",
		accessorFn: (row) => {
			return row.WcnNumber || "";
		},
		enableHiding: false,
		size: 40,
		header: "WCN",
	},
	{
		accessorKey: "CompanyName",
		accessorFn: (row) => {
			return row.CompanyName || "";
		},
		enableHiding: false,
		header: "Company",
		muiTableBodyCellProps: ({ row }) => ({
			sx: {
				minWidth: "300px", // Ensure the column doesn't expand beyond this width
				whiteSpace: "pre-line", // Allow preformatted text, respects line breaks
				wordWrap: "break-word", // Break words if they exceed the width
				overflowWrap: "break-word", // Ensure long words wrap to the next line
				fontWeight: row.original.IsParentReport ? "bold" : "null",
			},
		}),
	},
	{
		accessorKey: "Flag",
		accessorFn: (row) => {
			return row.Flag || "";
		},
		size: 40,
		header: "Flag",
	},
	{
		accessorKey: "ModifiedDate",
		accessorFn: (row) => (
			<span>{convertLocaltoUTCFormat(new Date(row.ModifiedDate))}</span>
		),
		size: 50,
		header: "Modified Date",
		enableColumnFilter: false,
	},
	{
		accessorKey: "ReportStartDate",
		accessorFn: (row) =>
			!row.IsParentReport && (
				<span>
					{convertLocaltoUTCFormat(new Date(row.ReportStartDate))}
				</span>
			),
		size: 50,
		header: "Report Start",
		enableColumnFilter: false,
	},
	{
		accessorKey: "ReportEndDate",
		accessorFn: (row) =>
			!row.IsParentReport && (
				<span>
					{convertLocaltoUTCFormat(new Date(row.ReportEndDate))}
				</span>
			),
		size: 50,
		header: "Report End",
		enableColumnFilter: false,
	},
	{
		accessorKey: "Submitted",
		accessorFn: (row) =>
			!row.IsParentReport &&
			row.Submitted && (
				<span>{convertLocaltoUTCFormat(row.Submitted)} </span>
			),
		size: 50,
		header: "Submitted",
		enableColumnFilter: false,
	},
	{
		accessorKey: "Correction",
		accessorFn: (row) => {
			return row.Correction && !row.IsParentReport
				? (
						<>
							<FontAwesomeIcon icon={faFlag} color="#da1f33" />
						</>
				  ) || ""
				: "";
		},
		size: 50,
		header: "Correction",
		enableColumnFilter: false,
	},
	{
		accessorKey: "AisStatus",
		accessorFn: (row) => {
			return row.AisStatus || "";
		},
		size: 40,
		header: "AIS Status",
		enableColumnFilter: false,
	},
];
